import React from "react";
import { Box, Slider, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setDiscountPct } from "../../../Redux/promoSimulatorSlice/promoSimulatorSlice";
import { theme } from "../../../Theme";

export default function DiscountSlider() {
  const dispatch = useDispatch();
  const discountPct = useSelector(
    (state) => state.promoSimulator.discountPct
  );

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={0.5}
      >
        <Typography variant="body2" color="text.secondary">
          Discount %
        </Typography>
        <Typography
          variant="body1"
          fontWeight={700}
          color={theme.palette.primary.main}
        >
          {discountPct}%
        </Typography>
      </Box>
      <Slider
        value={discountPct}
        min={0}
        max={100}
        step={1}
        onChange={(_, val) => dispatch(setDiscountPct(val))}
        sx={{ color: theme.palette.primary.main }}
        marks={[
          { value: 0, label: "0%" },
          { value: 50, label: "50%" },
          { value: 100, label: "100%" },
        ]}
      />
    </Box>
  );
}
